<template>
  <div class="">
    <div class="flex flex-col lg:flex-row items-center">
      <div class="h-30 w-30 p-1 rounded-full bg-yellow-brand flex items-center justify-center mb-2.5 lg:mb-0">
        <img v-if="image" :src="image" :alt="altText" class="h-full w-full rounded-full">
        <img v-else src="/img/ywa-avatar.png" alt="" class="h-full w-full rounded-full">
      </div>
      <div class="lg:pl-5">
        <p class="font-primary font-extrabold text-20 leading-1.2 mb-1.5 text-center lg:text-left">{{ source }}</p>
        <p class="font-primary font-extrabold text-blue-brand text-12 text-center lg:text-left">{{ sourceExtended }}</p>
      </div>
    </div>
    <div v-html="content" class="py-5 text-20 leading-1.6 text-center lg:text-left"></div>
  </div>
</template>

<script>
import get from 'lodash/get';

export default {
  props: {
    review: {
      type: Object,
      required: true,
    },
  },

  computed: {
    image() {
      return get(this.review, 'image.url');
    },

    altText() {
      return get(this.review, 'image.alt_text');
    },

    source() {
      return get(this.review, 'source');
    },

    sourceExtended() {
      return get(this.review, 'source_extended');
    },

    content() {
      return get(this.review, 'content');
    }
  },
};
</script>
